import Vue from 'vue';

Vue.component('vuetable-virtual-shift', () =>
    import(/* webpackChunkName: 'virtual-shift-index' */ './vuetable-virtual-shift.vue'),
);
